import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ErrorState } from '@/components/ui/ErrorState'

type ErrorBoundaryProps = {
  children: ReactNode
  onError?: (error: unknown, info: ErrorInfo) => void
}

type ErrorBoundaryState = {
  error: unknown
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { error }
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    this.props.onError?.(error, info)
  }

  private readonly reset = () => {
    this.setState({ error: null })
  }

  override render(): ReactNode {
    if (this.state.error !== null) {
      return <ErrorState error={this.state.error} onRetry={this.reset} />
    }

    return this.props.children
  }
}
